import React from 'react';

import { lazyComponentLoader } from '~/utils/component-loader/componentLoader';
import { NoSession } from '~/views/auth/no-session/NoSession';
import { Check } from '~/views/check';

import { appPaths, authPaths } from './app-paths';
import { AppRoute } from './Routes';

const Alfred = lazyComponentLoader(
  () =>
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: "alfred" */ '../views/alfred'
    ),
  'alfred'
);

export const routes: AppRoute[] = [
  {
    path: '/',
    element: <Alfred />,
  },
  {
    path: appPaths.base,
    element: <Alfred />,
  },
];

export const authRoutes: AppRoute[] = [
  {
    path: authPaths.login,
    element: <NoSession />,
  },
  {
    path: appPaths.check,
    element: <Check />,
  },
];
